<div class="wrapper shadowed">
    <form [formGroup]="searchForm"  (ngSubmit)="onSubmit()"  >
        <h4>Nombre de pannes par type pour une période donnée</h4>
        <br/>
        <div id="paragraphe">
            <p>Choisir une période :</p>

            <mat-form-field>
                <input matInput  [matDatepicker]="picker"
                    placeholder="Date de début" formControlName="startDate">
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker startView="year" ></mat-datepicker>
            </mat-form-field>
            <mat-form-field>
                <input matInput [matDatepicker]="picker1" placeholder="Date de fin" formControlName="endDate">
                <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                <mat-datepicker #picker1 startView="year" ></mat-datepicker>
            </mat-form-field>
        </div>

        <button type="submit" class="btn btn-primary">Valider</button>

    </form>

    <app-gmao-spinner *ngIf="isLoading"></app-gmao-spinner>
    
    
    <ng-container *ngIf="stats">
        
        <br/>

        <h5>Filtrer : </h5>

        <h4>Résultats</h4>

        <app-export-button [data]="stats"></app-export-button>
     
        <br/>
        
        <h5>Par catégorie</h5>

        <table class="table table-bordered table-sm" id="projet">
            <thead>
                <th>Catégorie</th>
                <th>Nombre</th>
            </thead>
            <tbody>
                <ng-container *ngFor="let stat of stats">
                <tr>
                    <td>{{stat.NOM}}</td>
                    <td>{{stat.NB}}</td>
                </tr>
            </ng-container> 
                <tr>
                    <td><b>Total</b></td>
                    <td><b>{{getTotal()}}</b></td>
                </tr>
            </tbody>
        </table>

       <!-- <h5>Par journée</h5>

        <table class="table table-bordered table-sm">
            <thead>
                <th>Jour</th>
                <th>Codes</th>
                <th>Nombre</th>
            </thead>
            <tbody>
               
                    <tr *ngFor="let detail of details">
                        <td>{{detail.date}}</td>
                        <td>
                            <div *ngFor="let panne of detail.pannes">
                                {{panne.code}}
                            </div>
                        </td>
                        <td>
                            <div *ngFor="let panne of detail.pannes">
                                {{panne.pannes.length}}
                            </div>
                        </td>
                    </tr>
               
            </tbody>
        </table>-->
    </ng-container>
    <br/>
</div>